import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { TextField, Checkbox, Card, Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { SelectField } from 'components';
import {
	SetFormState, SetSelectedDates, SetSelectedLogs,
	GetDriveTestsDrives, GetDriveTestsDates, GetDriveTestsLogs,
	GetDriveTest,
	GetDriveTestScannerCodes2g, GetDriveTestScannerCodes3g, GetDriveTestScannerCodes4g, GetDriveTestScannerCodes5g,
	GetDriveTestScanner,
	GetCrowdsourcing,
	GetFailuresPointsVoice, GetFailuresPointsPacket,
	SetSelectedDatesCompare
} from '../../actions/DualMapActions';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	drawer: {
		width: 420,
		maxWidth: '100%',
	},
	header: {
		padding: theme.spacing(2, 1),
		display: 'flex',
		justifyContent: 'space-between',
	},
	buttonIcon: {
		marginRight: theme.spacing(1),
	},
	content: {
		padding: theme.spacing(0, 3),
		flexGrow: 1,
	},
	contentSection: {
		padding: theme.spacing(2, 0),
	},
	contentSectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		cursor: 'pointer',
	},
	contentSectionContent: {},
	formGroup: {
		padding: theme.spacing(2, 0),
	},
	fieldGroup: {
		display: 'flex',
		alignItems: 'center',
	},
	field: {
		marginTop: 0,
		marginBottom: 0,
	},
	flexGrow: {
		flexGrow: 1,
	},
	addButton: {
		marginLeft: theme.spacing(1),
	},
	tags: {
		marginTop: theme.spacing(1),
	},
	minAmount: {
		marginRight: theme.spacing(3),
	},
	maxAmount: {
		marginLeft: theme.spacing(3),
	},
	radioGroup: {},
	actions: {
		padding: theme.spacing(3),
		'& > * + *': {
			marginTop: theme.spacing(2),
		},
	},
}));

const FiltersTop = (props) => {
	const { className, open, onClose, onFilter, filterDisabled, onClear, mapCompare, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.dualMapReducer.formState);

	const cities = useSelector((state) => state.dualMapReducer.cities);
	const drives = useSelector((state) => state.dualMapReducer.drives);
	const dates = useSelector((state) => state.dualMapReducer.dates);
	const selectedDates = useSelector((state) => state.dualMapReducer.selectedDates);
	const logs = useSelector((state) => state.dualMapReducer.logs);
	const selectedLogs = useSelector((state) => state.dualMapReducer.selectedLogs);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _handleChangeCity = (event) => {
		dispatch(GetDriveTestsDrives(event.target.value));
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
				selectedDrive: '',
				selectedDriveCompare: ''
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
		dispatch(SetSelectedDates([]));
		dispatch(SetSelectedDatesCompare([]));
		dispatch(SetSelectedLogs([]));
		// dispatch(SetSelectedLogsCompare(emptyDates));
	};

	const _handleChangeDrive = (event) => {
		dispatch(GetDriveTestsDates(formState.values.selectedCity, event.target.value));
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});

		dispatch(SetSelectedDates([]));
		dispatch(SetSelectedLogs([]));
	};

	const _handleCloseDates = (optionDates) => {
		dispatch(SetSelectedDates(optionDates));
		dispatch(GetDriveTestsLogs(formState.values.selectedCity, optionDates));

		dispatch(SetSelectedLogs([]));

		// Scanner
		if (formState.values.selectedKpiScannerTech === '4g' && formState.values.kpi4gScanner !== undefined) {
			dispatch(GetDriveTestScannerCodes4g(userId, '4g', formState.values.selectedCity, selectedDates, formState.values.freq4g, formState.values.top4g));
			dispatch(GetDriveTestScanner(
				userId, '4g', formState.values.selectedCity, selectedDates, formState.values.kpi4gScanner,
				formState.values.freq4g, formState.values.top4g, formState.values.scannerPci
			));
		} else if (formState.values.selectedKpiScannerTech === '3g' && formState.values.kpi3gScanner !== undefined) {
			dispatch(GetDriveTestScannerCodes3g(userId, '3g', formState.values.selectedCity, selectedDates, formState.values.freq3g, formState.values.top3g));
			dispatch(GetDriveTestScanner(
				userId, '3g', formState.values.selectedCity, selectedDates, formState.values.kpi3gScanner,
				formState.values.freq3g, formState.values.top3g, formState.values.scannerSc
			));
		} else if (formState.values.selectedKpiScannerTech === '2g' && formState.values.kpi2gScanner !== undefined) {
			dispatch(GetDriveTestScannerCodes2g(userId, '2g', formState.values.selectedCity, selectedDates, formState.values.freq2g, formState.values.top2g));
			dispatch(GetDriveTestScanner(
				userId, '2g', formState.values.selectedCity, selectedDates, formState.values.kpi2gScanner,
				formState.values.freq2g, formState.values.top2g, formState.values.scannerBsic
			));
		} else if (formState.values.selectedKpiScannerTech === '5g' && formState.values.kpi5gScanner !== undefined) {
			dispatch(GetDriveTestScannerCodes5g(userId, '5g', formState.values.selectedCity, selectedDates, formState.values.freq5g, formState.values.top5g));
			dispatch(GetDriveTestScanner(
				userId, '5g', formState.values.selectedCity, selectedDates, formState.values.kpi5gScanner,
				formState.values.freq5g, formState.values.top5g, formState.values.scannerNrPci
			));
		}
	};

	const _handleCloseLogs = (optionLogs) => {
		// UE
		if (formState.values.selectedKpiTech === '5g' && formState.values.kpi5g !== undefined) {
			dispatch(GetDriveTest(userId, '5g', formState.values.selectedCity, selectedDates, optionLogs, formState.values.kpi5g));
		} else if (formState.values.selectedKpiTech === '4g' && formState.values.kpi4g !== undefined) {
			dispatch(GetDriveTest(userId, '4g', formState.values.selectedCity, selectedDates, optionLogs, formState.values.kpi4g));
		} else if (formState.values.selectedKpiTech === '3g' && formState.values.kpi3g !== undefined) {
			dispatch(GetDriveTest(userId, '3g', formState.values.selectedCity, selectedDates, optionLogs, formState.values.kpi3g));
		} else if (formState.values.selectedKpiTech === '2g' && formState.values.kpi2g !== undefined) {
			dispatch(GetDriveTest(userId, '2g', formState.values.selectedCity, selectedDates, optionLogs, formState.values.kpi2g));
		} else if (formState.values.selectedKpiTech === 'common' && formState.values.kpiCommon !== undefined) {
			dispatch(GetDriveTest(userId, 'common', formState.values.selectedCity, selectedDates, optionLogs, formState.values.kpiCommon));
		}

		// Crowdsourcing
		// if (formState.values.selectedKpiCrowdsourcingTech === '4g' && formState.values.kpiCrowdsourcing4g !== undefined) {
		// 	dispatch(GetCrowdsourcing(userId, '4g', formState.values.selectedCity, selectedDates, formState.values.kpiCrowdsourcing4g));
		// } else if (formState.values.selectedKpiCrowdsourcingTech === '3g' && formState.values.kpiCrowdsourcing3g !== undefined) {
		// 	dispatch(GetCrowdsourcing(userId, '3g', formState.values.selectedCity, selectedDates, formState.values.kpiCrowdsourcing3g));
		// } else if (formState.values.selectedKpiCrowdsourcingTech === '2g' && formState.values.kpiCrowdsourcing2g !== undefined) {
		// 	dispatch(GetCrowdsourcing(userId, '2g', formState.values.selectedCity, selectedDates, formState.values.kpiCrowdsourcing2g));
		// }

		// Failures
		if (formState.values.voiceActive) {
			dispatch(
				GetFailuresPointsVoice(userId, role, formState.values.selectedCity, selectedDates, optionLogs, formState.values.failureTypeVoice, formState.values.cfn1LevelVoice)
			);
		}
		if (formState.values.packetActive) {
			dispatch(
				GetFailuresPointsPacket(userId, role, formState.values.selectedCity, selectedDates, optionLogs, formState.values.failureTypePacket, formState.values.cfn1LevelPacket)
			);
		}
	};

	const _handleChangeDates = (event, option, reason) => {
		dispatch(SetSelectedDates(option));
		if (reason === 'removeOption') {
			_handleCloseDates(option);
		}
	};

	const _handleChangeLogs = (event, option, reason) => {
		dispatch(SetSelectedLogs(option));
		if (reason === 'removeOption') {
			_handleCloseLogs(option);
		}
	};

	const cardStyle = {
		// height: '10vh'
	};

	return (
		<Card style={cardStyle}>
			<div className={classes.content}>
				<div className={classes.contentSection}>
					<Grid container spacing={1}>
						<Grid item md={mapCompare ? 2 : 2}>
							<SelectField
								id="selectedCity"
								name="selectedCity"
								hintText="City"
								defaultValue={formState.values.selectedCity || ''}
								menuItems={cities || []}
								onChange={_handleChangeCity}
								value={formState.values.selectedCity || ''}
							// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
							/>
						</Grid>
						<Grid item md={mapCompare ? 2 : 1}>
							<SelectField
								id="selectedDrive"
								name="selectedDrive"
								hintText="Drive"
								defaultValue={formState.values.selectedDrive || ''}
								menuItems={drives || []}
								onChange={_handleChangeDrive}
								value={formState.values.selectedDrive || ''}
							// error={_hasError('selectedCity') ? formState.errors.selectedCity[0] : null}
							/>
						</Grid>
						<Grid item md={mapCompare ? 6 : 2}>
							<Autocomplete
								// style={{ width: '70%' }}
								multiple
								disableCloseOnSelect
								limitTags={1}
								id="dates"
								options={dates}
								value={selectedDates}
								onChange={(event, value, reason) => { _handleChangeDates(event, value, reason); }}
								onClose={() => { _handleCloseDates(selectedDates); }}
								getOptionLabel={(option) => option.text}
								renderOption={(renderProps, option, { selected }) => (
									<li {...renderProps}>
										<Checkbox
											icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
											checkedIcon={<CheckBoxIcon fontSize="small" />}
											style={{ marginRight: 8 }}
											checked={selected}
										/>
										{option.text}
									</li>
								)}
								// defaultValue={[top100Films[13], top100Films[12], top100Films[11]]}
								renderInput={(params) => (
									<TextField {...params} label="Dates" placeholder="" />
								)}
							// sx={{ width: '500px' }}
							/>
						</Grid>
						<Grid item md={mapCompare ? 8 : 5}>
							<Autocomplete
								// style={{ width: '70%' }}
								multiple
								disableCloseOnSelect
								limitTags={1}
								id="logs"
								options={logs || []}
								value={selectedLogs}
								onChange={(event, value, reason) => { _handleChangeLogs(event, value, reason); }}
								onClose={() => { _handleCloseLogs(selectedLogs); }}
								getOptionLabel={(option) => option.text.slice(0, 32)}
								renderOption={(renderProps, option, { selected }) => (
									<li {...renderProps}>
										<Checkbox
											icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
											checkedIcon={<CheckBoxIcon fontSize="small" />}
											style={{ marginRight: 8 }}
											checked={selected}
										/>
										{option.text}
									</li>
								)}
								// defaultValue={[top100Films[13], top100Films[12], top100Films[11]]}
								renderInput={(params) => (
									<TextField {...params} label="Logs" placeholder="" />
								)}
							// sx={{ width: '500px' }}
							/>
						</Grid>
					</Grid>
				</div>
			</div>
		</Card>
	);
};

FiltersTop.propTypes = {
	className: PropTypes.string,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onFilter: PropTypes.func.isRequired,
	filterDisabled: PropTypes.bool,
	onClear: PropTypes.func,
	mapCompare: PropTypes.bool
};

export default FiltersTop;
